module.exports = __webpack_public_path__ + "2c454669bdf3aebf32a1bd8ac1e0d2d6.eot";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/fonts/themify.eot?v=1.0.0
// module id = 567
// module chunks = 0